// extracted by mini-css-extract-plugin
export var infoRow = "_rt-2";
export var labelContainer = "_rt-0";
export var rightInfo = "_rt-1";